import {useEffect, useState} from "react";
import apiErrorHandler from "../services/apiInstance/apiErrorHandler";
import api from "../services/apiInstance/api";

const useOrganizationTemplates = (organizationId, actual) => {
  const [isReadyToRender, setIsReadyToRender] = useState(false);
  const [errorObject, setErrorObject] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    api.getOrganizationTemplateList(organizationId)
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        setErrorObject(apiErrorHandler(error));
      })
      .finally(() => {
        setIsReadyToRender(true); // Only once
      });
  }, [organizationId, actual]);

  return { isReadyToRender, errorObject, setErrorObject, data};
};

export default useOrganizationTemplates;
